import { fromJS } from "immutable";

import TYPE from "../../constants/type";

const initialState = fromJS({
  isFetching: false,
  isUpdating: false,
  researchRewards: [],
});

export default function researchRewardReducer(state = initialState, action) {
  switch (action.type) {
    case TYPE.RESEARCH_REWARD.GET_RESEARCH_REWARDS_LOADING:
    case TYPE.RESEARCH_REWARD.RECALCULATE_RESEARCH_REWARDS_LOADING:
      return state.merge({ isFetching: true });

    case TYPE.RESEARCH_REWARD.UPDATE_RESEARCH_REWARD_STATUS_LOADING:
      return state.merge({ isUpdating: true });

    case TYPE.RESEARCH_REWARD.GET_RESEARCH_REWARDS_FAILURE:
    case TYPE.RESEARCH_REWARD.RECALCULATE_RESEARCH_REWARDS_FAILURE:
      return state.merge({ isFetching: false });

    case TYPE.RESEARCH_REWARD.UPDATE_RESEARCH_REWARD_STATUS_FAILURE:
      return state.merge({ isUpdating: false });

    case TYPE.RESEARCH_REWARD.GET_RESEARCH_REWARDS_SUCCESS:
      return state.merge({
        isFetching: false,
        researchRewards: action.payload,
      });

    case TYPE.RESEARCH_REWARD.RECALCULATE_RESEARCH_REWARDS_SUCCESS:
      return state.merge({ isFetching: false });

    case TYPE.RESEARCH_REWARD.UPDATE_RESEARCH_REWARD_STATUS_SUCCESS:
      return state.merge({ isUpdating: false });

    default:
      return state;
  }
}

